<template>
  <v-toolbar card color="transparent">
    <v-toolbar-side-icon>
      <v-icon class="grey--text">mdi-account</v-icon>
    </v-toolbar-side-icon>
    <v-toolbar-title class="subheading grey--text">
      Successful Reminder
    </v-toolbar-title>

    <v-spacer />

    <can I="edit" a="Opportunity">
      <v-menu left max-width="30vw" v-model="removing">
        <v-btn flat icon color="error" slot="activator">
          <v-icon size="18px">mdi-delete</v-icon>
        </v-btn>

        <v-card>
          <v-card-title class="headline">Are you sure?</v-card-title>
          <v-card-text>This will remove the successful reminder.</v-card-text>
          <v-card-actions>
            <v-btn flat block @click="removing = false" color="grey">
              cancel
            </v-btn>
            <v-btn block color="error" @click="remove">
              Delete
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
    </can>

    <can I="edit" a="Opportunity">
      <v-dialog v-model="editing" max-width="700">
        <v-card>
          <v-card-title class="headline">
            Send a successful reminder?
          </v-card-title>
          <v-card-text>
            This will encourage the candidate to review his other active applications and send a request to
            withdraw them if needed.
          </v-card-text>
          <v-card-actions><v-spacer />
            <v-btn flat @click="cancel" color="grey">
              cancel
            </v-btn>
            <v-btn @click="submit" color="primary">
              {{ behavior.id ? 'Update' : 'Create' }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </can>
  </v-toolbar>
</template>

<script>
// Vue Component
export default {
  props: {
    value: { type: Object },
  },
  data() {
    return {
      // Toggles
      editing: !this.value.id,
      removing: false,
      // Model
      behavior: Object.assign({ entry: true }, this.value),
      // Validations
      valid: !!this.value.id,
    }
  },

  computed: {
    opportunity() {
      return this.$store.getters['admin/opportunities/find']()
    },
  },

  methods: {
    cancel() {
      this.editing = false
      this.$store.dispatch('admin/opportunities/fetch', this.$route.params.id)
    },
    submit() {
      if (this.behavior.id) {
        // Updating
        this.$store.dispatch('admin/opportunities/updateBehavior', this.behavior).then(() => (this.editing = false))
      } else {
        // Creating
        this.$store.dispatch('admin/opportunities/createBehavior', this.behavior).then(() => (this.editing = false))
      }
    },
    remove() {
      this.$store.dispatch('admin/opportunities/removeBehavior', this.behavior)
    },
  },
}
</script>
